import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import PaginationTab from "../../../components/PaginationTab";
import SearchStaff from "../../../components/SearchStaff";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { HeaderSkeleton, PaginationSkeleton, TableSkeleton } from "./StaffTab";
const Permission = () => {
  const {
    staffs,
    fetchStaffs,
    fetchDepartments,
    isLoading,
    setSelectedStaff,
    setSelectedStaffIds,
    selectAll,
    setSelectAll,
    loadingStaffs
  } = useGlobalContext();

  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const [toggleDrop, setToggleDrop] = useState(false);

  const dropdownRef = useRef(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const staffDropDown = useRef(null);

  const handleSelectAll = () => {
    if (selectAll) {
      // If already selected, clear all selections
      setSelectedStaffIds([]);
    } else {
      // Select all staff IDs
      const allStaffIds = staffs.map((staff) => staff.staffDetails.id);
      setSelectedStaffIds(allStaffIds);
    }
    setSelectAll(!selectAll);
  };


  function handledrop() {
    setToggleDrop(!toggleDrop);
  }
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };



  useEffect(() => {
    if (staffs?.length == 0) {
      fetchStaffs();
      fetchDepartments();
    }
  }, []);



  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
    if (staffDropDown.current && !staffDropDown.current.contains(e.target)) {
      setToggleDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  if (loadingStaffs && !staffs) {
    return (
      <div className="mt-[20px] staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }

  return (
    <div className="mt-[20px] permisson-tab">
      <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between gap-[15px] lg:gap-[0px]">
        <SearchStaff dropdownRef={dropdownRef} setDropdownOpen={setDropdownOpen} toggleDropdown={toggleDropdown} isDropdownOpen={isDropdownOpen} />
      </div>

      <div className="flex border-1 shadow mt-4 p-0 border rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
        <div className="w-full">
          <table className="w-full table-section">
            <thead className="border-1 border">
              <th>Name</th>
              <th>Job Title</th>
              <th>Role</th>
            </thead>
            <tbody>
              {
                loadingStaffs && !staffs &&
                <tr className="h-[100px]">
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-center text-gray-600 text-xl"
                  >
                    <ClipLoader color="#27004a" size={50} />
                  </td>
                </tr>
              }

              {
                  !loadingStaffs && staffs && staffs?.map((items, index) => {
                  return (
                    <tr className="border">
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        <Link
                          onClick={() => setSelectedStaff(items)}
                          to={`/user-permission/${items?.staffDetails?.id}`}
                          className="font-medium text-[#8A25B0]"
                        >
                          {items?.name}
                        </Link>
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {items?.staffDetails?.job_title}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {items?.staffDetails?.role?.role_name}
                      </td>
                    </tr>
                  );
                })
              }
              {
                !loadingStaffs && staffs && staffs?.length === 0 &&
                <tr>
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-center text-gray-600 text-xl"
                  >
                    No Client Found
                  </td>
                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>
      <PaginationTab />
    </div>
  );
};

export default Permission;
